<template>
  <div>
    <textarea
      v-model="enrolmentPeriod.Instruction"
      class="form-control"
      :maxlength="
        type == 'Leave of Absence' || type == 'Leave Utilization Report'
          ? 5000
          : 10000
      "
      rows="10"
    ></textarea>
    <button
      type="button"
      @click="saveEnrolmentPeriodInstruction()"
      class="btn btn-primary mt-2"
    >
      Save
    </button>
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  props: ["type"],
  data() {
    return {
      enrolmentPeriod: {
        Id: null,
        FromDateStr: "",
        ToDateStr: "",
        Instruction: "",
        IsActive: false,
      },
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getEnrolmentPeriod() {
      let param = {
        Token: this.token,
        Type: this.type,
      };
      this.$store.state.isLoading = true;
      API.getEnrolmentPeriod(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record)
              this.enrolmentPeriod = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    saveEnrolmentPeriodInstruction() {
      if (
        !this.enrolmentPeriod.Instruction ||
        this.enrolmentPeriod.Instruction == ""
      ) {
        this.$swal("The instruction is empty.", { icon: "error" });
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "Are you sure you want to save the instruction?",
          icon: "info",
          buttons: true,
          dangerMode: false,
        }).then((willSave) => {
          if (willSave) {
            let param = {
              Token: this.token,
              Id: this.enrolmentPeriod.Id,
              Instruction: this.enrolmentPeriod.Instruction,
              Type: this.type,
            };

            this.$store.state.isLoading = true;

            API.saveEnrolmentPeriodInstruction(param)
              .then((response) => {
                this.$store.state.isLoading = false;
                if (response.data.success) {
                  this.$swal("Admin Instruction saved successfully!", {
                    icon: "success",
                  });
                } else {
                  this.$swal(response.data.message, { icon: "error" });
                }
              })
              .catch((error) => {
                this.$store.state.isLoading = false;
                this.$swal(error.response.data.Message, { icon: "error" });
              });
          }
        });
      }
    },
  },

  created() {
    this.getEnrolmentPeriod();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/System/AdminInstruction.vue